<template>
  <row :class="{active: shouldHighlight}">
    <column class="row-title">
      <p @click="linkSelected">
        {{ link.name }}
      </p>
    </column>
    <suffix>
      <div class="dropdown">
        <button class="dropdown-toggle btn-icon clear-area controllers" :id="`link_${link.id}_actions`" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <icon class="kebab"></icon>
          <span class="sr-only">More Actions Dropdown</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right" :aria-labelledby="`link_${link.id}_actions`">
          <li v-if="link.sort_order > 0">
            <button @click="changeSortOrderByOne(-1)" class="dropdown-item">Move Up</button>
          </li>
          <li v-if="link.sort_order < folder.bookmark_links.length">
            <button @click="changeSortOrderByOne(1)" class="dropdown-item">Move Down</button>
          </li>
          <li>
            <button @click="deleteLink" class="dropdown-item">Delete</button>
          </li>
        </ul>
      </div>
    </suffix>
  </row>
</template>

<script lang="ts">
  import Vue from 'vue';
  import BookmarkLink from "../../models/bookmarkLink";
  import {IBookmarkLink} from "../../interfaces/bookmarkLinkInterface";
  import BookmarkFolder from "../../models/bookmarkFolder";
  import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  import ConfigureSidebarInterfaceStoreMixin from "../../mixins/configureSidebarInterfaceStoreMixin";

  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    state: ['bookmarkMenu'],
    actions: [
      'updateBookmarkLink',
      'destroyBookmarkLink',
    ],
  });

  export default Vue.extend({
    mixins: [
      bookmarkMenuStoreMixin,
      ConfigureSidebarInterfaceStoreMixin
    ],
    props: {
      link: {
        type: Object as () => BookmarkLink,
        required: true,
      },
      folder: {
        type: Object as () => BookmarkFolder,
        required: true,
      },
    },
    computed: {
      isSelected() {
        if (this.selectedLink) {
          return (this.link.id === this.selectedLink.id);
        } else {
          return false;
        }
      },
      shouldHighlight() {
        const mode = this.interfaceMode;

        return this.isSelected && (
          (mode === ConfigureSidebarModes.showLink) || (mode === ConfigureSidebarModes.editLink)
        );
      }
    },
    methods: {
      linkSelected() {
        this.setInterfaceMode({mode: ConfigureSidebarModes.showLink, selected: this.link});
      },
      changeSortOrderByOne(change: 1 | -1): void {
        const oldPosition = this.link.sort_order;
        const newPosition = oldPosition + change;
        const linkToSwap = this.folder.bookmark_links.find(link => link.sort_order === newPosition);
        linkToSwap.sort_order = oldPosition;
        this.link.sort_order = newPosition;
        this.updateBookmarkLink({bookmarkLink: this.link});
      },
      deleteLink(link: IBookmarkLink): void {
        this.setInterfaceMode({mode: ConfigureSidebarModes.showFolder, selected: this.link.parent});
        this.destroyBookmarkLink({bookmarkLink: this.link});
      },
    },
  })
</script>
